module.exports = __webpack_public_path__ + "img/metricas-de-audiencia-principal-min.44d8ea56.png";